module.exports = __webpack_public_path__ + "img/1492686435.dcfc1a98.jpg";